import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import useGlobalStatus from '../../../hook/useGlobalStatus';
import Linkify from '../../../components/utilities/Linkify';
import { ContentCopyIcon } from '../../../components/customStyles/images';
import { ALERT_TYPE, SUCCESS_CPOY, ERROR_CPOY } from '../../../constants/alertMsg';

import gif_progress from '../../../assets/images/gif_progress_gpt.gif';

import { MugShot, MassageBox, ContentStyle } from './chatbotStyle';

const ChatItem = (props) => {
  const {
    chatData,
    chatIndex,
    chatLength,
    progress,
    isLastIndex,
    scrollToBottom,
  } = props;

  const { handleAlertMsgSettings } = useGlobalStatus();

  // 處理換行符號
  const paragraphs = chatData.text.split(/\n+/);

  const handleCopyContent = () => {
    navigator.clipboard.writeText(chatData.text)
      .then(() => {
        handleAlertMsgSettings(true, {
          type: ALERT_TYPE.SUCCESS,
          msg: SUCCESS_CPOY
        });
      })
      .catch(err => {
        handleAlertMsgSettings(true, {
          type: ALERT_TYPE.ERROR,
          msg: `${ERROR_CPOY} ${err}`
        });
      });
  }

  return (
    <>
      <Box>
        <MugShot role={chatData.role}>
          {chatData.role === 'user' &&
            <Typography variant='body_xs' sx={{ fontWeight: 600 }}>YOU</Typography>
          }
          {chatData.role !== 'user' &&
            <Typography variant='body_xs' sx={{ fontWeight: 600 }}>EBISU</Typography>
            // <FullImage src={logo_s} alt='HAi' />
          }
        </MugShot>
      </Box>
      {/* 等待AI回應 */}
      {progress && chatData.text === '......' &&
        <Stack variant='start-center' ml={1}>
          <img src={gif_progress} alt="Loading..." style={{ width: '30px' }} />
        </Stack>
      }
      {/* 直接顯示最後一筆訊息 */}
      {chatData.text !== '......' &&
        <MassageBox role={chatData.role}>
          <>
            {paragraphs.map((paragraph, index) => (
              <Linkify key={index} text={paragraph} textStyle={ContentStyle} />
            ))}
            {chatData.role !== 'user' &&
              <Stack variant="end-center">
                <Tooltip title="複製" placement="bottom">
                  <IconButton onClick={handleCopyContent}>
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            }
          </>
        </MassageBox>
      }
    </>
  )
}

export default ChatItem;